module.exports = __webpack_public_path__ + "img/sup-back-sd.194f1bd1.png";